import { render, staticRenderFns } from "./ListsPage.vue?vue&type=template&id=63c269af&scoped=true"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c269af",
  null
  
)

export default component.exports